/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

import { ChangeStatusRequest } from '../../models/change-status-request';
import { Region } from '../../models/region';

export interface ChangeActive$Params {
   body: ChangeStatusRequest;
}

export function changeActive(
   http: HttpClient,
   rootUrl: string,
   params: ChangeActive$Params,
   context?: HttpContext
): Observable<StrictHttpResponse<Region>> {
   const rb = new RequestBuilder(rootUrl, changeActive.PATH, 'put');
   if (params) {
      rb.body(params.body, 'application/json');
   }

   return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
         return r as StrictHttpResponse<Region>;
      })
   );
}

changeActive.PATH = '/api/weather/region/changeActive';
